import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from 'src/app/core/app-config/app-config.service';
import { UploadRequest } from '../models/upload-request';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { AttachDocument } from '../models/attach-document';
import { File } from '../models/attach-document/file.model';
import { LinkedObjectType } from '../enums/linked-object-type.enum';

@Injectable({
  providedIn: 'root'
})
export class AttachDocumentService extends BaseService {
  appConfigService: AppConfigService;
  constructor(
    httpClient: HttpClient,
    appConfigService: AppConfigService) {
    super(httpClient, appConfigService.configuration.apiConfig.attachDocumentUrl);
    this.appConfigService = appConfigService;
  }

  deleteAttachment(orderCode: string, fileNames: string[] = []) {
    const apiUrl = 'documents/instances/' + this.appConfigService.configuration.instanceName + '/orders/' + orderCode;
    return this.delete(apiUrl, fileNames);
  }

  uploadAttachment(request: UploadRequest[]) {
    const apiUrl = 'documents/instances/' + this.appConfigService.configuration.instanceName + '/UploadFile';
    return this.post(apiUrl, request, false, false);
  }

  downloadAttachment(name: string): Observable<Blob> {
    const apiUrl = 'documents/download' + `?fileName=${name}`;
    return this.getBlob(apiUrl);
  }

  getAttachments(orderCode: string): Observable<File[]> {
    const apiUrl = 'documents/instances/' + this.appConfigService.configuration.instanceName + '/orders/' + orderCode;
    return this.get<File[]>(apiUrl);
  }

  copyDocuments(
    orderReference: string, sourceInternalName: string[],
    attachDocumentsWithCode: { documents: AttachDocument[], sampleCode: string }[], sourceOrderReference: string) {
    const request: CopyRequest[] = [];
    if (attachDocumentsWithCode && attachDocumentsWithCode.length > 0) {
      let index = 0;
      attachDocumentsWithCode.forEach(documentWithCode => {
        documentWithCode.documents.forEach(document => {
          request.push({
            destinationInternalName: document.internalFileName,
            fileName: document.name,
            linkedObjectType: (!documentWithCode.sampleCode || documentWithCode.sampleCode.trim() === '') ? LinkedObjectType.Order : LinkedObjectType.Sample,
            orderCode: orderReference,
            sampleCode: documentWithCode.sampleCode,
            sourceOrderCode: sourceOrderReference,
            sourceInternalName: sourceInternalName[index++],
          });

          if (index >= sourceInternalName.length) {
            index = 0;
          }
        });

      });
      const apiUrl = 'documents/instances/' + this.appConfigService.configuration.instanceName + '/CopyFile';
      return this.post(apiUrl, request);
    }
  }
}

export interface CopyRequest {
  fileName: string;
  sourceInternalName: string;
  sourceOrderCode: string;
  destinationInternalName: string;
  linkedObjectType: LinkedObjectType;
  orderCode: string;
  sampleCode: string;
}
